var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundEgg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 563,
    height: 490,
    viewBox: "0 0 563 490",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M464.358 86.9777C565.829 154.695 593.526 291.347 526.223 392.198C458.919 493.05 322.1 519.911 220.629 452.194C119.159 384.477 -51.4395 152.459 15.8644 51.6079C83.1682 -49.2437 362.887 19.2607 464.358 86.9777Z",
    fill: "#F7F6EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundEgg2);
export default __webpack_public_path__ + "static/media/background-egg-2.9f910c9e30d93dd93a40de1558d18950.svg";
export { ForwardRef as ReactComponent };